export default __webpack_public_path__ + "static/cta-image-f70e87c3e648af7cdc5ac79eb73185f4.jpg";